import { Box, Button, Card, Export, Heading, TextBlock } from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";

import style from "./estimated-value-card.scss";
import {
    formatAssetValue,
    formatGroupedAmount,
    formatUpliftPercentage,
    totalEstimatedValue,
    upliftPercentage,
} from "./estimatedValue";
import UpliftIcon from "components/icons/UpliftIcon";
import { AssetValues } from "services/asset-management/AssetGradingService";

interface Props {
    values?: AssetValues;
    isLoading: boolean;
    isExporting?: boolean;
    onExport?: () => void;
}

export const EstimatedValueCard = (props: Props) => {
    const { t } = useTranslation();

    if (props.values === undefined) {
        return (
            <Card className={style.estimatedCard}>
                <TextBlock>{t("AssetManagement.value.estimatedValue.loading")}</TextBlock>
            </Card>
        );
    }

    const percentage = upliftPercentage(props.values);

    return (
        <Card className={style.estimatedCard}>
            <Box columnLayout gap="Sm">
                <Box columnLayout gap="Xxs">
                    <Box verticalAlignment="Center" gap="Sm">
                        <Heading variant="h1" disableTopSpacing disableBottomSpacing className={style.estimatedValue}>
                            {formatAssetValue(formatGroupedAmount(totalEstimatedValue(props.values)))}
                        </Heading>
                        {percentage !== undefined && (
                            <span className={style.upliftBadge}>
                                <UpliftIcon />
                                {formatUpliftPercentage(percentage)}
                            </span>
                        )}
                    </Box>
                    <TextBlock disableBottomSpacing className={style.baselineCaption}>
                        {t("AssetManagement.value.estimatedValue.estimatedVsBaseline", {
                            value: formatAssetValue(formatGroupedAmount(props.values.value)),
                        })}
                    </TextBlock>
                </Box>
                <Button
                    variant="Primary"
                    icon={<Export />}
                    disabled={props.onExport === undefined || props.isExporting === true}
                    onClick={props.onExport}
                    className={style.exportButton}
                >
                    {t("AssetManagement.value.estimatedValue.saveAndExportDispositionPlan")}
                </Button>
            </Box>
        </Card>
    );
};
